import { Segment, Header, Grid, Menu, Dropdown } from "semantic-ui-react";
import AdminLicenceRenewalsGrid from "./AdminLicenceRenewalsGrid";
import { LicenceRenewal } from "../models/LicenceRenewal";
import { Organization } from "../models/Organization";

interface Props {
  isLicenceRenewalsLoading: boolean;
  licenceRenewals?: LicenceRenewal[] | null;
  organizations?: Organization[] | null;
  pageCount?: number;
  onPageInfoChange: (pageSize: number, pageIndex: number) => void;
  onOrgFilter: (orgId: string) => void;
}

const AdminLicenceRenewalsList = ({
  isLicenceRenewalsLoading,
  licenceRenewals,
  organizations,
  pageCount,
  onPageInfoChange,
  onOrgFilter,
}: Props) => {
  const handleOrgFilterChange = (e: any, { name, value }: any) => {
    onOrgFilter(value === "" ? null : value);
  };

  return (
    <>
      <Segment basic>
        <Header as="h2">Licence renewals</Header>
      </Segment>

      <Menu pointing secondary color="green">
        <Menu.Menu position="right">
          <Menu.Item>
            <Dropdown
              placeholder="Organization"
              basic
              clearable
              onChange={handleOrgFilterChange}
              options={organizations?.map((o) => ({ key: o.id, text: o.name, value: o.id }))}
            ></Dropdown>
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Segment basic loading={isLicenceRenewalsLoading}>
        <Grid columns="1">
          <Grid.Row>
            <Grid.Column width="16">
              <AdminLicenceRenewalsGrid
                licenceRenewals={licenceRenewals}
                pageCount={pageCount}
                onPageInfoChange={onPageInfoChange}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </>
  );
};

export default AdminLicenceRenewalsList;
